
import { useEffect } from 'react';
import { InitiationStep } from '@/hooks/initiation';

interface InitiationWrapperProps {
  mobileDetected: boolean;
  currentStep: InitiationStep;
  children: React.ReactNode;
}

const InitiationWrapper = ({ mobileDetected, children }: InitiationWrapperProps) => {
  // Check for wallet connection on focus/visibility change (helps with mobile flow)
  useEffect(() => {
    if (mobileDetected) {
      const handleVisibilityChange = () => {
        if (document.visibilityState === 'visible') {
          console.log('App back in focus, checking wallet connection state');
          // This helps to detect when user returns from wallet app on mobile
        }
      };
      
      // Add visibility change listener
      document.addEventListener('visibilitychange', handleVisibilityChange);
      
      return () => {
        document.removeEventListener('visibilitychange', handleVisibilityChange);
      };
    }
    // Return undefined explicitly for non-mobile cases
    return undefined;
  }, [mobileDetected]);

  // Check for direct URL access and intent
  useEffect(() => {
    const hasIntent = localStorage.getItem('cipher-intent') === 'true';
    if (!hasIntent) {
      console.log("Direct access attempt - no cipher intent detected");
    }
  }, []);

  return (
    <div className="max-w-3xl mx-auto w-full">
      {children}
    </div>
  );
};

export default InitiationWrapper;
